import { render, staticRenderFns } from "./IdeasoftSelectOrder.vue?vue&type=template&id=bd1cdfbc"
import script from "./IdeasoftSelectOrder.vue?vue&type=script&lang=js"
export * from "./IdeasoftSelectOrder.vue?vue&type=script&lang=js"
import style0 from "./IdeasoftSelectOrder.vue?vue&type=style&index=0&id=bd1cdfbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports